import React, { useState } from 'react';

import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../../../shared/AuthContext';

const Component = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, login, loadingSession } = useAuth();
  const fromPath = location.state?.from || '/dashboard';

  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  if (!loadingSession && isAuthenticated) {
    return <Navigate replace to="/dashboard" />;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');
    setSaving(true);
    try {
      await login({
        email: form.email.trim(),
        password: form.password,
      });
      navigate(fromPath, { replace: true });
    } catch (err) {
      setError(err?.response?.data?.message || err.message || 'Unable to sign in.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="auth-shell">
      <form className="card auth-card stack" onSubmit={handleSubmit}>
        <div className="stack-sm">
          <h1 className="page-title">Sign in</h1>
          <p className="page-subtitle">Use your invited account credentials to continue.</p>
        </div>

        {error ? <p className="error-text">{error}</p> : null}

        <label>
          Email
          <input
            autoComplete="email"
            type="email"
            value={form.email}
            onChange={(event) => setForm((prev) => ({ ...prev, email: event.target.value }))}
            required
          />
        </label>
        <label>
          Password
          <input
            autoComplete="current-password"
            type="password"
            value={form.password}
            onChange={(event) => setForm((prev) => ({ ...prev, password: event.target.value }))}
            required
          />
        </label>

        <button className="button-primary" disabled={saving} type="submit">
          {saving ? 'Signing in...' : 'Sign in'}
        </button>

        <div className="row-between">
          <Link className="inline-link" to="/forgot-password">Forgot password?</Link>
          <Link className="inline-link" to="/accept-invite">Accept invite</Link>
        </div>
        <div className="row-right">
          <Link className="inline-link" to="/bootstrap-admin">First-time setup</Link>
        </div>
      </form>
    </div>
  );
};

export default Component;
